import { Link } from "react-router-dom";
import { NETWORKS, SITE, SOCIAL_LINKS } from "@/data/networks";
import { LogoMark } from "./Logo";

export const Footer = () => (
  <footer className="bg-[#181412] text-[#C8BFB8]" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
      <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3 text-[#FBF8F4]">
            <LogoMark className="h-7 w-7 text-[#D4A373]" />
            <span className="font-serif text-2xl">HearthVault</span>
          </div>
          <p className="mt-4 max-w-sm text-sm leading-relaxed">
            The family document safe. Quietly organized for the moment it matters.
          </p>
          <a href={SITE} data-testid="footer-site-link" className="mt-6 inline-block text-sm text-[#FBF8F4] underline underline-offset-4 decoration-[#D4A373] hover:text-[#D4A373] transition-colors">hearthvault.family</a>
        </div>
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#D4A373]">Follow</div>
          <ul className="mt-4 space-y-2.5 text-sm">
            {NETWORKS.map((n) => (
              <li key={n.key}>
                <a href={SOCIAL_LINKS[n.key]} target="_blank" rel="noopener noreferrer" data-testid={`footer-follow-${n.key}`} className="inline-flex items-center gap-2 hover:text-[#FBF8F4] transition-colors">
                  <n.Icon className="h-4 w-4" /> {n.name}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#D4A373]">Channel pages</div>
          <ul className="mt-4 space-y-2.5 text-sm">
            <li><Link to="/" data-testid="footer-page-hub" className="hover:text-[#FBF8F4] transition-colors">All channels</Link></li>
            {NETWORKS.map((n) => (
              <li key={n.key}><Link to={`/${n.key}`} data-testid={`footer-page-${n.key}`} className="hover:text-[#FBF8F4] transition-colors">HearthVault on {n.name}</Link></li>
            ))}
            <li><Link to="/checklist" data-testid="footer-page-checklist" className="hover:text-[#FBF8F4] transition-colors">The kitchen-table checklist</Link></li>
            <li><Link to="/partners" data-testid="footer-page-partners" className="hover:text-[#FBF8F4] transition-colors">Creators &amp; partners</Link></li>
          </ul>
        </div>
      </div>
      <div className="mt-20 font-serif text-[18vw] lg:text-[200px] leading-[0.8] tracking-tight text-[#FBF8F4]/[0.06] select-none" aria-hidden="true">Hearthside</div>
      <div className="mt-6 flex flex-col sm:flex-row justify-between gap-3 border-t border-[#FBF8F4]/10 pt-6 text-xs">
        <span>© {new Date().getFullYear()} HearthVault</span>
        <span className="flex gap-5">
          <a href={`${SITE}/trust`} data-testid="footer-trust-link" className="hover:text-[#FBF8F4]">Trust center</a>
          <a href={`${SITE}/pricing`} data-testid="footer-pricing-link" className="hover:text-[#FBF8F4]">Pricing</a>
        </span>
      </div>
    </div>
  </footer>
);
